"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DtoChangeOrderStatusCancelledSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const DtoChangeOrderStatusBaseSchema_1 = require("./DtoChangeOrderStatusBaseSchema");
exports.DtoChangeOrderStatusCancelledSchema = DtoChangeOrderStatusBaseSchema_1.DtoChangeOrderStatusBaseSchema.concat(joi_1.default.object({
    submission: {
        cancelledBy: joi_1.default.string().allow('Location', 'Photographer', 'Customer', 'Lemon One').required(),
        cancellationTimeFrame: joi_1.default.string().allow('>72h', '48-72h', '24-48h', '12-24h', '1-12h', '<1h').required()
    }
})).meta({ className: 'DtoChangeOrderStatusCancelled' });
//# sourceMappingURL=DtoChangeOrderStatusCancelledSchema.js.map